import React, { useEffect } from "react";

import Navbar from "components/Navbar.js";
import Footer from "components/Footer.js";
import AOS from "aos";
import { useDispatch, useSelector } from "react-redux";
import { sendEmail } from "store/sendEmailSlice";
import { Helmet } from "react-helmet-async";
import CustomerReview from "components/CustomerReview";
import { getAbout } from "store/configDataSlice";
import "../styles/landing-animations.css";
import "../styles/portfolio-gallery.css";
import "../styles/about-studio.css";
import "../styles/contact-studio.css";

const portfolioCategories = [
  {
    title: "Bridal",
    route: "Bridal",
    image: require("assets/img/portfolio-thumbnails/bridal.jpg").default,
    alt: "Bridal makeup look from Arpita's Makeover",
  },
  {
    title: "Reception",
    route: "Reception",
    image: require("assets/img/portfolio-thumbnails/reception.jpg").default,
    alt: "Reception makeup look from Arpita's Makeover",
  },
  {
    title: "Western & Party",
    route: "Western",
    image: require("assets/img/portfolio-thumbnails/western-party.jpg").default,
    alt: "Western and party makeup look from Arpita's Makeover",
    contain: true,
  },
  {
    title: "Hair Style",
    route: "Hair Style",
    image: require("assets/img/portfolio-thumbnails/hair-style.jpg").default,
    alt: "Bridal hairstyle from Arpita's Makeover",
  },
  {
    title: "Others",
    route: "Others",
    image: require("assets/img/portfolio-thumbnails/others.jpg").default,
    alt: "Occasion makeup look from Arpita's Makeover",
  },
];

export default function Landing(props) {
  const dispatch = useDispatch();
  const emailReducerState = useSelector((state) => state.emailReducer);
  const state = useSelector((state) => state);
  console.log("states are", state);
  const [userData, setUserData] = React.useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      offset: 80,
      once: true,
    });
    dispatch(getAbout(
      "Every look starts with a conversation about your occasion, your personal style, and how you want to feel. From bridal, reception and engagement makeup to party looks, hairstyling and saree draping, each detail is tailored to complement your features—so you feel at ease, look radiant, and still feel like yourself."
    ));
  }, []);

  const viewImage = (data) => {
    props.history.push(`/imageDetails/${data}`);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(sendEmail(e));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  return (
    <>
      <Helmet>
        <title>arpita's makeover</title>
        <meta
          name="description"
          content="Thoughtful makeup and styling by Arpita's Makeover in Kolkata. Bridal, reception, engagement and party looks, with hairstyling for the moments that matter."
        />
        <link rel="canonical" href="/" />
      </Helmet>
      <Navbar transparent daraProps={props} />
      <main>
        <div
          className="relative pt-16 pb-16 flex content-center items-center justify-center"
          style={{
            minHeight: "100vh",
          }}
        >
          <div
            className="backgroundImage absolute top-0 w-full h-full bg-top bg-cover"
            // style={{backgroundImage:"url('https://github.com/shyamalVixplor/MyPersonalImages/blob/main/bridal.jpg?raw=true')"}}
          >
            <span
              id="blackOverlay"
              className="w-full h-full absolute opacity-50 bg-black"
            ></span>
          </div>
          <div className="container relative mx-auto">
            <div className="items-center flex flex-wrap">
              <div className="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">
                <div>
                  <h1 className="text-white font-semibold text-5xl" data-aos="fade-up">
                    Beauty for the{" "}
                    <span className="text-orange-500">moments that matter.</span>
                  </h1>
                  <p className="mt-4 text-lg text-gray-300" data-aos="fade-up" data-aos-delay="140">
                    {state?.appConfigReducer?.landingDesc}
                  </p>
                  {/* <a href="#" class="bg-transparent hover:bg-orange-500 text-orange-500 font-semibold hover:text-white p-4 border border-orange-500 hover:border-transparent rounded inline-block mt-5 cursor-pointer">
                      Download Brochure
                    </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* About Section */}
        <section id="about" className="about-studio" aria-labelledby="about-heading">
          <div className="about-studio__container">
            <div className="about-studio__layout">
              <div className="about-studio__visual" data-aos="fade-right">
                <div className="about-studio__portrait-frame">
                  <img
                    alt="Arpita wearing a western and party makeup look"
                    className="about-studio__portrait"
                    src={require("assets/img/western15.jpeg").default}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="about-studio__portrait-note">
                  <span className="about-studio__note-icon" aria-hidden="true">
                    <i className="fas fa-magic" />
                  </span>
                  <span>
                    <strong>Arpita's Makeover</strong>
                    <small>Beauty, with a personal touch</small>
                  </span>
                </div>
              </div>

              <div className="about-studio__content" data-aos="fade-left">
                <p className="about-studio__eyebrow">
                  <span aria-hidden="true" /> About my makeup studio
                </p>
                <h2 id="about-heading">
                  Your occasion. Your style. <em>Your kind of beautiful.</em>
                </h2>
                <p className="about-studio__description">
                  {state?.appConfigReducer?.makeupAbout}
                </p>

                <ul className="about-studio__highlights">
                  <li>
                    <span className="about-studio__highlight-icon" aria-hidden="true">
                      <i className="fas fa-fingerprint" />
                    </span>
                    <span>
                      <strong>Thoughtfully tailored</strong>
                      <small>Styles that complement your features, outfit, and taste</small>
                    </span>
                  </li>
                  <li>
                    <span className="about-studio__highlight-icon" aria-hidden="true">
                      <i className="fas fa-paint-brush" />
                    </span>
                    <span>
                      <strong>From ceremony to celebration</strong>
                      <small>Bridal, reception, engagement, and party looks</small>
                    </span>
                  </li>
                  <li>
                    <span className="about-studio__highlight-icon" aria-hidden="true">
                      <i className="fas fa-users" />
                    </span>
                    <span>
                      <strong>Clear, considered pricing</strong>
                      <small>Choose the services that fit your plans and budget</small>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Makeup portfolio */}
        <section
          id="portfolio"
          className="portfolio-gallery"
          aria-labelledby="portfolio-heading"
        >
          <div className="portfolio-gallery__container">
            <header className="portfolio-gallery__intro" data-aos="fade-up">
              <p className="portfolio-gallery__eyebrow">Arpita's Makeover · Portfolio</p>
              <h2 id="portfolio-heading">A look for every moment</h2>
              <p>
                Explore makeup and styling from celebrations, special occasions,
                and the moments you want to remember.
              </p>
              <span className="portfolio-gallery__ornament" aria-hidden="true">
                <span />
                <i className="fas fa-gem" />
                <span />
              </span>
            </header>

            <div className="portfolio-gallery__grid">
              {portfolioCategories.map((category, index) => (
                <button
                  className={`portfolio-gallery-card${
                    category.contain ? " portfolio-gallery-card--contain" : ""
                  }`}
                  key={category.route}
                  type="button"
                  aria-label={`View all ${category.title} photos`}
                  data-aos="fade-up"
                  data-aos-delay={Math.min(index * 80, 240)}
                  onClick={() => viewImage(category.route)}
                >
                  <span className="portfolio-gallery-card__image">
                    <img
                      src={category.image}
                      alt={category.alt}
                      loading="lazy"
                      decoding="async"
                    />
                    <span className="portfolio-gallery-card__shade" aria-hidden="true" />
                    <span className="portfolio-gallery-card__number" aria-hidden="true">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                    <span className="portfolio-gallery-card__image-label">
                      <i className="fas fa-images" aria-hidden="true" />
                      Portfolio collection
                    </span>
                  </span>
                  <span className="portfolio-gallery-card__details">
                    <span className="portfolio-gallery-card__title">{category.title}</span>
                    <span className="portfolio-gallery-card__action">
                      View All
                      <i className="fas fa-arrow-right" aria-hidden="true" />
                    </span>
                  </span>
                </button>
              ))}
            </div>
          </div>
        </section>
        {/* <section> */}
        {/* <section className="pt-20 pb-20">
          <div className="container mx-auto px-4"> */}
        <CustomerReview/>
        {/* </div>
        </section> */}
{/* </section> */}
        <section className="contact-studio" id="contact">
          <div className="contact-studio__glow" aria-hidden="true" />
          <div className="contact-studio__container">
            <div className="contact-studio__intro" data-aos="fade-up">
              <span className="contact-studio__eyebrow">
                <span aria-hidden="true" /> Get in touch
              </span>
              <h2>Let’s make your next occasion unforgettable.</h2>
              <p>
                Feel free to share your query with us. Tell us about the look
                you have in mind and we’ll help you plan the details.
              </p>
              <div className="contact-studio__highlights">
                <div className="contact-studio__highlight">
                  <span className="contact-studio__highlight-icon" aria-hidden="true">
                    <i className="far fa-clock" />
                  </span>
                  <span>
                    <strong>Thoughtful, personal service</strong>
                    <small>We’ll get back to you within 24 hours.</small>
                  </span>
                </div>
                <a className="contact-studio__highlight" href="tel:9932142591">
                  <span className="contact-studio__highlight-icon" aria-hidden="true">
                    <i className="fas fa-phone-alt" />
                  </span>
                  <span>
                    <strong>Prefer to talk?</strong>
                    <small>Call the studio: +91 99321 42591</small>
                  </span>
                </a>
              </div>
            </div>

            <div className="contact-studio__form-card" data-aos="fade-up" data-aos-delay="100">
              <div className="contact-studio__form-heading">
                <div>
                  <span className="contact-studio__form-kicker">Start a conversation</span>
                  <h3>Tell us what you’re looking for</h3>
                </div>
                <span className="contact-studio__form-mark" aria-hidden="true">
                  <i className="far fa-paper-plane" />
                </span>
              </div>
              <form className="contact-studio__form" onSubmit={handleSubmit}>
                <div className="contact-studio__field-grid">
                  <div className="contact-studio__field">
                    <label htmlFor="contact-name">Full name</label>
                    <input
                      type="text"
                      placeholder="Your name"
                      onChange={handleChange}
                      id="contact-name"
                      name="name"
                      autoComplete="name"
                      required
                    />
                  </div>
                  <div className="contact-studio__field">
                    <label htmlFor="contact-email">Email address</label>
                    <input
                      type="email"
                      placeholder="you@example.com"
                      onChange={handleChange}
                      id="contact-email"
                      name="email"
                      autoComplete="email"
                      required
                    />
                  </div>
                </div>
                <div className="contact-studio__field">
                  <label htmlFor="contact-subject">What can we help with?</label>
                  <input
                    type="text"
                    placeholder="e.g. Bridal makeup enquiry"
                    onChange={handleChange}
                    id="contact-subject"
                    name="subject"
                    required
                  />
                </div>
                <div className="contact-studio__field">
                  <label htmlFor="contact-message">A few details</label>
                  <textarea
                    rows="4"
                    placeholder="Share your occasion date, preferred look, or any questions..."
                    onChange={handleChange}
                    id="contact-message"
                    name="message"
                    required
                  />
                </div>
                <div className="contact-studio__form-footer">
                  <p>We usually reply within 24 hours.</p>
                  <button type="submit" disabled={emailReducerState.sendEmailLoading}>
                    {emailReducerState.sendEmailLoading ? "Please wait…" : "Send enquiry"}
                    {!emailReducerState.sendEmailLoading && (
                      <i className="fas fa-arrow-right" aria-hidden="true" />
                    )}
                  </button>
                </div>
                {emailReducerState.sendEmailSuccess && (
                  <p className="contact-studio__form-status contact-studio__form-status--success" role="status" aria-live="polite">
                    Thanks for reaching out. Your enquiry has been sent.
                  </p>
                )}
                {emailReducerState.sendEmailError && (
                  <p className="contact-studio__form-status contact-studio__form-status--error" role="alert">
                    We couldn’t send your enquiry right now. Please try again or call the studio at +91 99321 42591.
                  </p>
                )}
              </form>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
